import { BASE_URL_MAP } from "~/core/constants/constants";
import type LxcError from "~/core/models/LxcError.class";
import type { FiltersSelection } from "~/core/models/filters";
import RestService from "~/core/services/rest.service";
import businessUnitService from "~/modules/businessUnit/services/businessUnit.service";
import type { OrganizationCreate } from "~/modules/organization/models/OrganizationCreate.type";
import type { OrganizationUpdate } from "~/modules/organization/models/OrganizationUpdate.type";
import type { OrganizationV2 } from "~/modules/organization/models/OrganizationV2.interface";

export class OrganizationService extends RestService {
  getOrganizations(
    businessUnitCode: number,
    filter?: string | FiltersSelection,
  ): Promise<OrganizationV2[]> {
    let params = {};

    if (filter) {
      params = { ...params, filter };
    }
    return this.$apiV2.get(
      this.getBusinessUnitOrganizationsPath(businessUnitCode),
      {
        params,
      },
    );
  }

  getOrganization(organizationCode: number): Promise<OrganizationV2> {
    return this.$apiV2.get(this.getOrganizationPath(organizationCode));
  }

  createOrganization(
    businessUnitCode: number,
    organization: OrganizationCreate,
    createAffiliation: boolean = false,
    createDelegation: boolean = false,
    targetOrganizationCode?: number,
  ): Promise<OrganizationV2> {
    return this.$apiV2.post(
      this.getBusinessUnitOrganizationsPath(businessUnitCode),
      organization,
      {
        params: {
          createAffiliation,
          createDelegation,
          targetOrganizationCode,
        },
      },
    );
  }

  updateOrganization(
    organizationCode: number,
    organization: OrganizationUpdate,
  ): Promise<OrganizationV2 | LxcError> {
    return this.$apiV2.put(
      this.getOrganizationPath(organizationCode),
      organization,
    );
  }

  getOrganizationsPath(): string {
    return BASE_URL_MAP.ORGANIZATIONS;
  }

  getOrganizationPath(organizationCode?: number): string {
    if (!organizationCode) {
      throw new Error("Organization code is undefined");
    }
    return `${this.getOrganizationsPath()}/${organizationCode}`;
  }

  getBusinessUnitOrganizationsPath(businessUnitCode: number) {
    return `${businessUnitService.getBusinessUnitPath(businessUnitCode)}/${this.getOrganizationsPath()}`;
  }
}
export default new OrganizationService();
